import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 px-6 md:px-10">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className={`text-xl md:text-2xl font-bold tracking-tight ${scrolled || !isHome ? "text-foreground-950" : "text-white"}`}>
            今日大瓜
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled || !isHome ? "text-foreground-700 hover:text-foreground-950" : "text-white/90 hover:text-white"
            } ${location.pathname === "/" ? (scrolled || !isHome ? "text-foreground-950" : "text-white") : ""}`}
          >
            首页
          </Link>
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? "text-foreground-700 hover:text-foreground-950" : "text-white/80 hover:text-white"
              } ${location.pathname === `/category/${cat.slug}` ? (scrolled || !isHome ? "text-foreground-950" : "text-white") : ""}`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled || !isHome ? "text-foreground-700 hover:text-foreground-950" : "text-white/80 hover:text-white"
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:block">
          <a
            href="#subscribe"
            className={`inline-flex items-center gap-2 px-5 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
              scrolled || !isHome
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 border border-white/30"
            }`}
          >
            订阅瓜报
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
            scrolled || !isHome ? "text-foreground-950" : "text-white"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="flex flex-col px-6 py-4 gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-950 py-2 cursor-pointer">首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium text-foreground-700 py-2 cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm font-medium text-foreground-700 py-2 cursor-pointer">关于我们</Link>
            <a
              href="#subscribe"
              className="inline-flex items-center gap-2 justify-center px-5 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 mt-2 cursor-pointer"
            >
              订阅瓜报
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}